import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/services/interceptor/loader.service';
import { MainService } from 'src/app/services/main/main.service';
import { SocketsService } from 'src/app/services/shared/socket.service';
import { getUserProfile } from 'src/app/core/session';

@Component({
  selector: 'app-scan-upload',
  templateUrl: './scan-upload.component.html',
  styleUrls: ['./scan-upload.component.scss']
})
export class ScanUploadComponent implements OnInit {
  claim_docs: any = [];
  fileToUpload: File = null;
  fileFormatError = false;
  fileSizeError = false;
  fileType = 'image/jpeg,image/gif,image/png,application/pdf,image/x-eps';
  temp_claim_id: any;
  upload_more_docs = 0;
  missing_payment_id: any;
  // profile = getUserProfile() || [];
  profile = localStorage.getItem('userProfileData') ? getUserProfile() : {};
  temparray: any = [];
  clamisData: any = {
    contract_id: '',
    temp_claim_id: '',
    claim_id: '',
    doctor_id: ''
  };
  public queryParamSubscription: Subscription;
  qrData: any;
  isDisabld = true;
  step = 0;
  selectedIndex = 0;
  needMoreDoc: any = {};
  disable_more = false;
  showError = false;
  isMobileDevice = true;
  constructor(
    public mainService: MainService,
    public route: ActivatedRoute,
    public _socket: SocketsService,
    public loaderService: LoaderService,

  ) {
  }

  ngOnInit() {
    this.queryParamSubscription = this.route.queryParams.subscribe(params => {
      if (params.contractId || params.tempId) {
        this.clamisData.temp_claim_id = params.contractId || params.tempId;
        this.getDetails();
      } else if (params.claimId) {
        this.needMoreDoc.claimId = params.claimId;
        this.isMobileDevice = window.innerWidth < 768;
        this.getDetailsForNeedDoc(params.claimId);
      }
    });
  }
  getDetails() {
    const data: any = {
      temp_claim_id: this.clamisData.temp_claim_id,
      type: '2',
      is_scan: 1
    };
    this.mainService.api(data, 'scan_claim_qrcode ', false)
      // tslint:disable-next-line:no-shadowed-variable
      .subscribe((data: any) => {
        if (data.is_error === 0) {
          this.qrData = data.data[0];
          this.claim_docs = this.qrData.document_types;
          this.claim_docs.forEach((document, index) => {
            if (this.qrData.claim_docs && this.qrData.claim_docs.length) {
              this.qrData.claim_docs.forEach(ele => {
                if (document.document_type == ele.document_type) {
                  this.claim_docs[index].is_required = 0;
                  this.claim_docs[index].is_uploading = false;
                  this.claim_docs[index].is_uploaded = true;
                  this.claim_docs[index].claim_doc_id = ele.claim_doc_id;
                  this.claim_docs[index].doc_file = ele.doc_file;
                  this.claim_docs[index].filename = ele.doc_name;
                } else {
                  this.claim_docs[index].is_required = ele.is_required;
                }
              });
            }
          });
          const requiredFiles = this.claim_docs.filter(item => item.is_required == 1 && !item.file);
          this.isDisabld = requiredFiles && requiredFiles.length ? true : false;
        } else {
          this.mainService.customPopups(data.err, data.is_error);
        }
      });
  }

  handleFileInput(index: any, files: any) {
    this.claim_docs[index].is_deleting = false;
    this.claim_docs[index].is_uploaded = true;
    // this.temparray.push(this.fileToUpload);
    const requiredFiles = this.claim_docs.filter(item => item.is_required == 1 && !item.doc_file);
    this.isDisabld = requiredFiles && requiredFiles.length ? true : false;
    this.step = 0;
  }
  remoeveFile(index: any) {
    this.claim_docs[index].is_uploaded = false;
    this.claim_docs[index].file = null;
    this.temparray.splice(index, 1);
    const requiredFiles = this.claim_docs.filter(item => item.is_required == 1 && !item.file);
    this.isDisabld = requiredFiles && requiredFiles.length ? true : false;
  }

  checkClaimStatus(index: any, files: FileList) {
    this.fileSizeError = false;
    this.fileFormatError = false;
    this.fileToUpload = files.item(0);
    if (this.fileToUpload.size > 1024 * 1024 * 10) {
      this.fileSizeError = true;
      this.fileToUpload = null;
      this.mainService.customPopups('File size must be less than 10MB.', 1);
      return false;
    }
    if (!(this.fileToUpload.type == 'image/jpeg' || this.fileToUpload.type == 'image/png' || this.fileToUpload.type == 'application/pdf')) {
      this.fileFormatError = true;
      this.fileToUpload = null;
      this.mainService.customPopups('File type not supported. Please upload a valid file(.pdf, .jpeg, .png).', 1);
      return false
    }


    if (this.needMoreDoc && this.needMoreDoc.claimId) {
      this.uploadDocSingle(1, index);
    } else {
      this.uploadDocSingle(0, index);
    }
  }

  uploadDoc() {
    const form = new FormData();
    // this.claim_docs.forEach((file, index) => {
    //   form.append('document_file', file);
    // });
    form.append('document_type', JSON.stringify(this.claim_docs));
    form.append('temp_claim_id', this.clamisData.temp_claim_id);
    form.append('doctor_id', this.qrData.doctor_id);
    this.mainService.uploadApi(form, 'upload_multiple_claim_doc', false)
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.step = 2;
        }
        if (data.is_error == 1) {
          if (data.override_text) {
            this.mainService.customPopups(data.override_text, 1);
          } else {
            this.mainService.flagPopUps(data.flag, data.is_error);
          }
        }
      }, (error: any) => {
        console.log(error);
      });
  }

  getDetailsForNeedDoc(id: any) {
    const data: any = {
      claim_id: id,
    };
    this.mainService.api(data, 'scan_more_doc_qrcode ', false)
      // tslint:disable-next-line:no-shadowed-variable
      .subscribe((data: any) => {
        if (data.is_error === 0) {
          this.claim_docs = data.data.more_documents;
          this.needMoreDoc.name = data.data.patient_first_name + ' ' + data.data.patient_last_name;
          this.needMoreDoc.amount = data.data.claim_expected_amount || 0;
          this.needMoreDoc.contract_code = data.data.contract_code;
          this.needMoreDoc.contract_id = data.data.contract_id;
          this.needMoreDoc.doctor_id = data.data.doctor_id;
          this.claim_docs.forEach((document, index) => {
            document['is_required'] = 1;
          });
          this.generateMoreDocQr();
        } else {
          if (data.flag == 551) {
            this.showError = true;
          } else {
            this.mainService.customPopups(data.err, data.is_error);
          }
        }
      });
  }

  uploadDocForNeedMore() {
    const form = new FormData();
    form.append('document_file', JSON.stringify(this.claim_docs));
    form.append('doctor_id', this.needMoreDoc.doctor_id);
    form.append('contract_id', this.needMoreDoc.contract_id);
    form.append('claim_id', this.needMoreDoc.claimId);
    this.mainService.uploadApi(form, 'upload_multiple_more_doc', false)
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.step = 2;
        }
        if (data.is_error == 1) {
          if (data.override_text) {
            this.mainService.customPopups(data.override_text, 1);
          } else {
            this.mainService.flagPopUps(data.flag, data.is_error);
          }
        }
      }, (error: any) => {
        console.log(error);
      });
  }


  copyObject(obj) {
    const element = Object.assign({}, obj);
    element.is_uploaded = false;
    element.is_uploading = false;
    element.filename = '';
    element.file = '';
    element.progress = 0;
    let obj_count = 1;
    this.claim_docs.forEach((item) => {
      if (item.document_type == obj.document_type) {
        obj_count++;
      }
    });
    if (obj_count == obj.document_limit) {
      this.disable_more = true;
    }
    this.claim_docs.push(element);
  }

  deleteObject(index) {
    this.disable_more = false;
    this.claim_docs.splice(index, 1);
  }

  compressImage(file: File, maxWidth = 800, maxHeight = 800, quality = 0.2): Promise<File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) { return reject('Failed to get canvas context'); }
          // Set the dimensions for compression
          let width = img.width;
          let height = img.height;
  
          // Adjust dimensions to maintain aspect ratio
          if (width > height && width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          } else if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }
  
          // Resize and compress the image
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
  
          // Convert the canvas to a Blob, then to a File
          canvas.toBlob((blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, { type: file.type });
              resolve(compressedFile); // Resolve the promise with the compressed file
            } else {
              reject('Compression failed');
            }
          }, file.type, quality);
        };
  
        img.onerror = () => reject('Image loading failed');
      };
  
      reader.onerror = () => reject('File reading failed');
    });
  }

  uploadDocSingle(type: any, index) {
    this.loaderService.show();
    const form = new FormData();
    if (!type) {
      form.append('temp_claim_id', this.clamisData.temp_claim_id);
      form.append('document_type', this.claim_docs[index].document_type);
      form.append('doctor_id', this.qrData.doctor_id);
      form.append('document_file', this.fileToUpload);
      this.mainService.uploadApi(form, 'upload_claim_doc_by_scan', false)
        .subscribe((data: any) => {
          this.loaderService.hide();
          if (data.is_error == 0) {
            this.claim_docs[index].doc_file = data.file_link;
            this.handleFileInput(index, this.fileToUpload);
          }
          if (data.is_error == 1) {
            if (data.override_text) {
              this.mainService.customPopups(data.override_text, 1);
            } else {
              this.mainService.flagPopUps(data.flag, data.is_error);
            }
          }
        }, (error: any) => {
          console.log(error);
        });
    } else {
      form.append('more_id', this.claim_docs[index].more_id);
      form.append('doctor_id', this.needMoreDoc.doctor_id);
      form.append('document_file', this.fileToUpload);
      this.mainService.uploadApi(form, 'upload_more_doc_by_scan', false)
        .subscribe((data: any) => {
          this.loaderService.hide();
          if (data.is_error == 0) {
            this.claim_docs[index].doc_file = data.file_link;
            this.handleFileInput(index, this.fileToUpload);
          }
          if (data.is_error == 1) {
            if (data.override_text) {
              this.mainService.customPopups(data.override_text, 1);
            } else {
              this.mainService.flagPopUps(data.flag, data.is_error);
            }
          }
        }, (error: any) => {
          console.log(error);
        });
    }
  }


  generateMoreDocQr() {
    const data: any = {
      is_scan: 1,
      doctor_id: this.needMoreDoc.doctor_id,
      claim_id: this.needMoreDoc.claimId,
    };
    this.mainService.api(data, 'generate_more_docs_qrcode', false)
      // tslint:disable-next-line:no-shadowed-variable
      .subscribe((data: any) => {
        if (data.is_error === 0) {
          this.qrData = data.data;
        } else {
          this.mainService.customPopups(data.err, data.is_error);
        }
      });
  }

}
